export const EVSE_ID_COUNTRY_CODES = [
  'AT',
  'BE',
  'CH',
  'DE',
  'DK',
  'ES',
  'FR',
  'GB',
  'IT',
  'LU',
  'NL',
  'PL',
  'PT',
  'SE',
];

export const getEvseIdError = (evseId: string) => {
  if (!evseId) {
    return null;
  }

  if (evseId.length > 30) {
    return {
      content: 'Station ID is too long (maximum 27 characters).',
      pointing: 'above',
    };
  }

  if (evseId.length < 7) {
    return {
      content: 'Station ID is too short (minimum 7 characters).',
      pointing: 'above',
    };
  }

  if (!validateEvseId(evseId)) {
    return {
      content:
        'Invalid Station ID. Use 7-27 characters and only letters (A-Z, a-z), digits (0-9), and asterisks (*).',
      pointing: 'above',
    };
  }

  return null;
};

const validateEvseId = (id: string) => {
  const pattern = /^[A-Za-z0-9*]{7,30}$/;
  return pattern.test(id);
};
